import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlightClassIcon from '@mui/icons-material/FlightClass';
import { TRAVEL_CLASS } from '~/literals';
import { TravelClassOption } from '~/types';

export interface KeyDisplayOption {
  key: string,
  display: string,
}

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));


interface TravelClassSelectorProps {
  onSelect: (selectedItem: KeyDisplayOption) => void;
  selectedKey: string;
}

const TravelClassSelector: React.FC<TravelClassSelectorProps> = ({ onSelect, selectedKey }) => {
  const Classes: KeyDisplayOption[] = Object.keys(TRAVEL_CLASS).map(key => ({ key, display: TRAVEL_CLASS[key as keyof TravelClassOption] }))
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selected, setSelected] = React.useState<string>(TRAVEL_CLASS[selectedKey as keyof TravelClassOption]);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (item: KeyDisplayOption) => {
    setSelected(item.display);
    onSelect(item);
    handleClose();
  };

  return (
    <div>
      <Button
        id="flight-class-selector-button"
        aria-controls={open ? 'flight-class-selector-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<ExpandMoreIcon style={{ fontSize: 25 }} />}
        startIcon={<FlightClassIcon style={{ fontSize: 25 }} />}  // Icon on the left side of the button
        style={{
          backgroundColor: 'transparent',
          textTransform: 'capitalize',
          fontSize: '1rem',
          color: '#000',
          fontWeight: 'normal'
        }}
      >
        {selected}
      </Button>
      <StyledMenu
        id="flight-class-selector-menu"
        MenuListProps={{
          'aria-labelledby': 'flight-class-selector-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {Classes.map((item) => (
          <MenuItem
            key={item.key}
            onClick={() => handleMenuItemClick(item)}
          >
            {item.display}
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
};

export default TravelClassSelector;

